
import ZoneForm from 'scripts/defa/zones/view-zone-form';
import template from 'templates/zoneModeForm.jst.html';
import { Vue }  from 'vue/defavue';

/**
 * ZoneModeForm
 * A view for changing zone modes
 * @version 1.3.0
 */

const ZoneModeForm = ZoneForm.extend({
	
	// ----------------------------------
	// setup
	// ----------------------------------
	
	template: template,
	
	onDomRefresh: function(){
		let self   = this;
		new Vue ({
			el: '#zone-mode',
			
			bb() {
				return {
					model: self.model.getModel('5')
				};
			},
			
			data() {
				return {
					selectedMode: '',
					hasThermostat: self.model.hasThermostat(),
					// locked: !self.options.settingsHome.get('zone'+self.model.get('zoneNumber')).enabled,
				}
			},
			methods : {
				save() {
					let data = {};
					data.zoneMode = this.selectedMode;
					self.saveModel('5',  data )
				},
				
				onModeChange: function (newValue) {
					this.selectedMode = newValue;
					this.save()
				},
				onClickCancel: function () {
					self.trigger('close', self);
				}
				
			},
			
			computed: {
				validMode: function () {
					return this.model.zoneMode !== null ? this.model.zoneMode !== this.selectedMode : false
				}
			},
			
			watch : {
				'model.zoneMode' : function (newValue){
					this.selectedMode = newValue;
				}
			},
			
			created () {
				this.selectedMode = this.model.zoneMode;
				this.hasThermostat = self.model.hasThermostat();
			}
		});
		
		
	},
	
	
	saveModel: function (modelNumber, attrs) {
		let self = this;
		self.busy();
		try {
			let model = self.model.getModel(modelNumber);
			model.save( attrs, {
				patch: true,
				isSaving: true,
				success: function () {
					console.log( Object.keys(attrs)[0] +' was succesfully saved!' );
					self.idle();
				},
				error  : function (model, response) {
					console.error( Object.keys(attrs)[0] + ' failed saving with error: ' + response.responseJSON.message );
					self.idle();
				}
			} );
		} catch ( err ) {
			console.error( err );
			setTimeout( () => this.idle(), 1000 );
		}
	},
	
	
});

export default ZoneModeForm;
